// extracted by mini-css-extract-plugin
export var active = "_b9-7";
export var container = "_b9-0";
export var evenWidth = "_b9-4";
export var large = "_b9-5";
export var outlet = "_b9-8";
export var slide = "_b9-2";
export var small = "_b9-6";
export var tab = "_b9-3";
export var tabs = "_b9-1";